import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getNotices () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Notice',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  addNoticeRead (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'NoticeRead',
        params,
        response => {
          if (!response || !response.data) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        err => {
          reject(err)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/noticeservice.js